/* global axios */
import ApiClient from '../ApiClient';

class GmbChannel extends ApiClient {
  constructor() {
    super('gmb', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new GmbChannel();
